var jQuery = window.jQuery; // TODO: require("jquery");

var PJAX_CONTAINER = ".js-neo-pjax-content";

function log() {
  if(window.console && window.console.log) {
    console.log.apply(console, arguments);
  }
}

function eval_all_script_tags($new_content) {
  var all = $new_content.find('script');
  for (var n = 0; n < all.length; n++) {
    eval(all[n].innerHTML);
  }
}

function pjax_complete(event) {
  // reload advertisements
  try {
    if (window.IQD_ReloadHandle) {
      IQD_ReloadHandle();
    } else {
      log('Ad lib IQD_ReloadHandle not defined')
    }
    
  } catch(e) {
    log("PJAX completed: Could not reload advertisements. Error:", e);
  }

  // execute tracking again
  try {
    if (window.VALITON_WA) {
      VALITON_WA.track()
    } else {
      log('Tracking lib VALITON_WA not defined')
    }
  } catch(e) {
    log("PJAX completed: Could not execute tracking again. Error:", e);
  }

  // scroll to quiz body
  jQuery("body, html").animate({
    scrollTop: jQuery(PJAX_CONTAINER).offset().top - 80
  }, 0);
}

(function($) {
  // Initialize PJAX and register handler for when requests are completed.
  $.pjax.defaults.timeout = 15000;
  $.pjax.defaults.scrollTo = false;
  $.pjax.defaults.fragment = PJAX_CONTAINER;

  $(document).pjax(PJAX_CONTAINER+' a[target!="_blank"]', PJAX_CONTAINER)
    .on('pjax:complete', pjax_complete)
    .on('pjax:error', function(xhr, textStatus, error, options) { log("error", xhr, textStatus, error, options); })
    .on("pjax:timeout", function(xhr, options) { log("timeout", xhr, options); });
})(jQuery);
